// extracted by mini-css-extract-plugin
module.exports = {"ridb-header":"Header-ridb-header--2BkYY","logo":"Header-logo--3A1Qi","menuItem":"Header-menuItem--3JBxM","active":"Header-active--2nDCA"};